<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow min-w-0 overflow-hidden">
      <main class="w-full">
        <DashboardComponent />
      </main>
    </div>
  </div>
</template>

<script>
import DashboardComponent from '@/components/DashboardComponent.vue';
import Sidebar from '@/components/SidebarComponent.vue';

export default {
  name: 'DashboardView',
  components: {
    DashboardComponent,
    Sidebar,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>